import request from '@/utils/request'

export function getDBFUrl () {
    return request({
      url: '/api/TutorComm/GetDBFUrl',
      method: 'post'
    })
}

export function hasClickedDraBoatFesDialog(){
    return request({
        url:'/api/TutorComm/HasClickedDraBoatFesDialog',
        method: 'post'
    })
}

export function insertTuDraBoatFesDialogClickedRecord(){
    return request({
        url:'/api/TutorComm/InsertTuDraBoatFesDialogClickedRecord',
        method: 'post'
    })
}

export function updateTuDraBoatFesDialogClickedRecord(num){
    return request({
        url:'/api/TutorComm/UpdateTuDraBoatFesDialogClickedRecord',
        method: 'post',
        data:{IsClose:num}
    })
}

export function insertTuDraBoatFesRecord(BannerId,endType,clickType){
    return request({
        url:'/api/TutorComm/InsertTuDraBoatFesRecord',
        method: 'post',
        data:{BannerId:BannerId,EndType:endType,ClickType:clickType}
    })
}

export function updateTuDraBoatFesRecord(){
    return request({
        url:'/api/TutorComm/UpdateTuDraBoatFesRecord',
        method: 'post',
    })
}

export function getDBFDuration(){
    return request({
        url:'/api/TutorComm/GetDBFDuration',
        method: 'post'
    })
}



